import * as dashboard from "./dashboard";
import * as clientsList from "./clients-list";
import * as clientDetail from "./client-detail";
import * as compareClients from "./compare-clients";
import * as saturdayQueue from "./saturday-queue";
import * as kiosk from "./kiosk";
import * as pendingApprovals from "./pending-approvals";
import * as reports from "./reports";
import * as sharingTree from "./sharing-tree";
import * as importCsv from "./import-csv";
import * as auditLog from "./audit-log";
import * as settings from "./settings";
import * as staffUsers from "./staff-users";
import * as profile from "./profile";
import * as clientPortal from "./client-portal";

export const ALL_ARTICLES = [
  dashboard,
  clientsList,
  clientDetail,
  compareClients,
  saturdayQueue,
  kiosk,
  pendingApprovals,
  reports,
  sharingTree,
  importCsv,
  auditLog,
  settings,
  staffUsers,
  profile,
  clientPortal,
];

export const SECTIONS = ["Core", "Programs", "Administration"];

export function getArticle(slug) {
  return ALL_ARTICLES.find((a) => a.slug === slug);
}

export const ROUTE_ARTICLE_MAP = {
  "/staff/dashboard": "dashboard",
  "/staff/clients": "clients-list",
  "/staff/queue": "saturday-queue",
  "/staff/pending": "pending-approvals",
  "/staff/reports": "reports",
  "/staff/sharing-tree": "sharing-tree",
  "/staff/import": "import-csv",
  "/staff/audit": "audit-log",
  "/staff/settings": "settings",
  "/staff/users": "staff-users",
  "/staff/profile": "profile",
  "/staff/kiosk": "kiosk",
  "/staff/clients/compare": "compare-clients",
};

export function getArticleSlugForRoute(pathname) {
  if (ROUTE_ARTICLE_MAP[pathname]) return ROUTE_ARTICLE_MAP[pathname];
  if (/^\/staff\/clients\/.+/.test(pathname)) return "client-detail";
  return "dashboard";
}
